module.exports = require('./helpers/bundle-url').getBundleURL('aK4Nu') + "TUSDLogo.df934baa.svg";